import api from "../../config/client.axios.api";

export const acceptSolutionApi = async (id: any) => {
  const response = await api.put(`/solution/accept-request?solution_id=${id}`);
  return response.data;
};
